import React from "react";
import { Link } from "react-router-dom";

import bgCard from "../../../../img/cardbg.jpg";
import namebanner from "../../../../img/bwhite.png";

const Agent = (props) => {
  const { name, img } = props.agent;

  const routeChange = () => {
    props.history.push(`/agents/${name}`);
  };

  return (
    <div
      onClick={
        props.active ? () => routeChange() : () => props.setnow(props.index)
      }
      className='cardmain'
    >
      <div
        id={`card-${props.index}`}
        className='card relative bg-red-800 flex flex-col items-center justify-evenly'
        style={{
          background: `url(${bgCard}) no-repeat `,
          backgroundSize: "cover",
        }}
      >
        <img className='absolute z-30 namebanner' src={namebanner} alt='' />
        <h1 className='absolute z-40 namebannertext text-gray-900 tracking-widest font-extrabold text-2xl uppercase'>
          {name}
        </h1>
        <img className='characterimage' src={img} alt='' />
      </div>
    </div>
  );
};

export default Agent;
